import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../service/util.service';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { UserProfile } from '../../models/user-profile.model';
import { ReceivingRequestSummaryService } from './receiving-request-summary.service';
import { UserData } from '../../providers/user-data';
import * as XLSX from 'xlsx';
import { Storage } from '@ionic/storage';
import { ReceivingRequestSummaryComponent } from '../../component/advanced-filter/receiving-request-summary/receiving-request-summary.component';
@Component({
  selector: 'app-receiving-request-summary',
  templateUrl: './receiving-request-summary.page.html',
  styleUrls: ['./receiving-request-summary.page.scss'],
})
export class ReceivingRequestSummaryPage implements OnInit {
  rows: any=[];
  tempRows : any=[];
  keywordSearch:any='';
  token: any;
  userProfile: UserProfile = new UserProfile();
  userAccess: any[] = [];
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: '',
    orderDir: 'desc'
  };
  counterList: any[] = [];
  counterId:any='';

  paramProductReceivingId: any = null;
  paramProductRequestId: any = null;
  paramBranchIdList: any[]=[];
  paramCounterIdList: any[]=[];
  paramWarehouseIdList: any[]=[];
  paramDocStartDate: any = null;
  paramDocEndDate: any = null;
  branchList:any[]=[];
  warehouseList:any[]=[];
  branchNameList:any='';
  warehouseNameList:any='';
  counterNameList:any='';

  reportData: any[] = [];
  reportDataDetail: any[] = [];

  constructor(
    private utilService:UtilService,
    private receivingRequestService: ReceivingRequestSummaryService,
    private toastCtrl:ToastController,
    private navCtrl:NavController,
    private userData: UserData,
    private modalController:ModalController,
    private storage: Storage,
  ) { }

  ngOnInit() {
    
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userAccess = access;
          this.userProfile = new UserProfile(profile);
          let counterId = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
          
          this.reloadTable();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  
  getDataForAdvancedFilter() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list,
      };

      this.receivingRequestService.getDataforAdvancedFilter(options)
      .subscribe((response) => {
        this.utilService.loadingDismiss();
        this.counterList = response.results.counter_data;

        this.pageCallback({ offset: this.page.offset });
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        this.pageCallback({ offset: this.page.offset });
      });
    });
  }
  
  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }
  
  sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.reloadTable();
  }

  reloadTable() {
    console.log(this.userProfile.counter_id_list)
    this.rows =[];
    this.tempRows = [];
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let offset = this.page.offset + 1;
      let branchIds: any[]=[];
      let counterIds: any;
      let warehouseIds: any;
      let userCounterIds =  counterIds = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
      if(this.paramBranchIdList.length>0) { 
        branchIds = this.paramBranchIdList; 
      }
      if(this.paramCounterIdList.length>0) { 
        counterIds = this.paramCounterIdList; 
      }
      else { counterIds = userCounterIds;
      }
      if(this.paramWarehouseIdList.length>0) { 
        warehouseIds = this.paramWarehouseIdList; 
      }
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0];
      let options = {
        "token": this.token,
        "page": offset.toString(),
        "branch_id_list": branchIds,
        "counter_id_list": counterIds,
        "warehouse_id_list": warehouseIds,
        "user_counter_id_list":userCounterIds,
        "product_request_id":this.paramProductRequestId,
        "product_receiving_id":this.paramProductReceivingId,
        "doc_start_date": this.paramDocStartDate ? this.paramDocStartDate : todayStr,
        "doc_end_date": this.paramDocEndDate ? this.paramDocEndDate : todayStr,
      };
      this.receivingRequestService.getReceivingRequestSummary(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.rows = response.data.summary;
        this.tempRows = response.data.summary;
        this.branchList = response.data.branch_list;
        this.counterList = response.data.counter_list;
        this.warehouseList = response.data.warehouse_list;
        //this.filteredData = response.results.data;
        //this.productRequestList = response.results.data;
      }, (err) => {
        this.utilService.loadingDismiss();
        console.log(err);
        if(err.error.error === 'token_expired') {
          this.userData.logout().then(() => {
            this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
            this.navCtrl.navigateForward(['/login']);
          });
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      });
    });
  }


  exportToExcel() {
  const element = document.getElementById('excel-table');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

  // === AUTO WIDTH ===
  const colWidths = [];
  const range = XLSX.utils.decode_range(ws['!ref']!);

  for (let C = range.s.c; C <= range.e.c; ++C) {
    let maxWidth = 10;

    for (let R = range.s.r; R <= range.e.r; ++R) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = ws[cellAddress];
      if (!cell || !cell.v) continue;

      const cellLength = cell.v.toString().length;
      maxWidth = Math.max(maxWidth, cellLength);
    }

    colWidths.push({ wch: maxWidth + 2 }); // +2 biar lega
  }

  ws['!cols'] = colWidths;
  // === END AUTO WIDTH ===

  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  XLSX.writeFile(wb, 'Report Summary Permintaan Penerimaan Barang.xlsx');
}


  async openAdvancedFilters() {
    const modal = await this.modalController.create({
      component: ReceivingRequestSummaryComponent,
      componentProps: {
        branchList:this.branchList,
        counterList: this.counterList,
        warehouseList: this.warehouseList,
        paramProductReceivingId: this.paramProductReceivingId,
        paramProductRequestId: this.paramProductRequestId,
        paramBranchIdList: this.paramBranchIdList,
        paramCounterIdList: this.paramCounterIdList,
        paramWarehouseIdList: this.paramWarehouseIdList,
        paramDocStartDate: this.paramDocStartDate,
        paramDocEndDate: this.paramDocEndDate
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      console.log(data)
      if (data.length > 0) {
        let arrBranch = [];
        if(data[0].branchId.length>0){
          for(let i=0;i<data[0].branchId.length;i++){
            arrBranch.push(data[0].branchId[i].id);
          }
        }
        let arrCounter = [];
        if(data[0].counterId.length>0){
          for(let i=0;i<data[0].counterId.length;i++){
            arrCounter.push(data[0].counterId[i].id);
          }
        }
        let arrWarehouse = [];
        if(data[0].warehouseId.length>0){
          for(let i=0;i<data[0].warehouseId.length;i++){
            arrWarehouse.push(data[0].warehouseId[i].id);
          }
        }
        this.paramProductReceivingId = data[0].productReceivingId;
        this.paramProductRequestId = data[0].productRequestId;
        this.paramBranchIdList = arrBranch;
        this.paramCounterIdList = arrCounter;
        this.counterNameList = data[0].counterName;
        this.paramWarehouseIdList = arrWarehouse;
        this.warehouseNameList = data[0].warehouseName;
        this.paramDocStartDate = data[0].docStartDate;
        this.paramDocEndDate = data[0].docEndDate;

        this.reloadTable();
      }
    });

    return await modal.present();
  }
  searchWithKeywords() {
    const keyword = this.keywordSearch
      ? this.keywordSearch.toLowerCase()
      : '';

    // kalau kosong → balikin semua data
    if (!keyword) {
      this.rows = this.tempRows;
      return;
    }

    this.rows = this.tempRows.filter(row => {
      return (
        (row.branch_name && row.branch_name.toLowerCase().indexOf(keyword) !== -1) ||
        (row.counter_name && row.counter_name.toLowerCase().indexOf(keyword) !== -1) ||
        (row.warehouse_name && row.warehouse_name.toLowerCase().indexOf(keyword) !== -1) ||
        (row.request_number && row.request_number.toString().indexOf(keyword) !== -1) ||
        (row.receiving_number && row.receiving_number.toString().indexOf(keyword) !== -1) ||
        (row.request_date && row.request_date.indexOf(keyword) !== -1)
      );
    });
  }
  
}
